import { Button } from '@synoptic/ui-kit/button/button.tsx';
import {
  DropdownMenuContent,
  DropdownMenuRoot,
  DropdownMenuTrigger,
} from '@synoptic/ui-kit/dropdown-menu/dropdown-menu.js';
import { DropdownMenuItem } from '@synoptic/ui-kit/dropdown-menu/dropdown-menu.tsx';
import { MenuIcon } from '@synoptic/ui-kit/icons/react/menu.tsx';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { FC } from 'react';
import { flags } from '@/feature-flags/flags.ts';
import { useFeatureFlags } from '@/feature-flags/use-feature-flags.ts';
import { useAppLoader } from '../../loader.ts';
import { useAuthInfo } from '../../use-auth-info.ts';
import {
  menuItemButton,
  menuItemText,
  moreMenuDropdownItem,
} from './menu-action/menu-action.css.ts';
import { menuActions } from './menu-actions.tsx';
import { moreMenuDropdown } from './menu.css.ts';

const mobileMenuActions = [
  menuActions.Streams,
  menuActions.CustomStreams,
  menuActions.StreamPackages,
  menuActions.Terminal,
  menuActions.StreamDeck,
  menuActions.LearningCenter,
  menuActions.Report,
  menuActions.Tools,
  menuActions.Charts,
  menuActions.Enterprise,
  menuActions.Admin,
];

export const MoreMenu: FC = () => {
  const isTablet = useIsTablet();
  const { isAdmin } = useAuthInfo();
  const { authenticated } = useAppLoader();
  const chartsEnabled = useFeatureFlags(flags.streamTimeSeries);

  const menuItems = isTablet
    ? []
    : mobileMenuActions.filter((action) => {
        if (action === menuActions.Admin) {
          return isAdmin;
        }
        if (action === menuActions.Charts) {
          return authenticated && chartsEnabled;
        }
        return true;
      });

  return menuItems.length > 0 ? (
    <DropdownMenuRoot>
      <DropdownMenuTrigger>
        <Button
          className={menuItemButton}
          startIcon={<MenuIcon />}
          variant="ghost"
        >
          <span className={menuItemText}>More</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className={moreMenuDropdown}>
        {menuItems.map((item, index) => (
          <DropdownMenuItem
            key={index}
            className={moreMenuDropdownItem}
            asChild
          >
            {item}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenuRoot>
  ) : null;
};
